import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../contexts/CartContext";

export default function StoreSuccess() {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const { clear } = useCart();
    const [order, setOrder] = useState(null);

    useEffect(() => {
        if (!sessionId) return;
        api.get(`/store/orders/by-session/${sessionId}`)
            .then((r) => { setOrder(r.data); clear(); })
            .catch(() => { /* ignore */ });
    }, [sessionId, clear]);

    return (
        <div data-testid="store-success" className="grain max-w-3xl mx-auto px-5 md:px-10 py-24 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/15 border border-gold/40 mb-6">
                <Check className="text-gold" size={30} />
            </div>
            <h1 className="h-display text-5xl">Order Confirmed</h1>
            <p className="text-ink text-base mt-4 max-w-lg mx-auto">
                Thanks for repping the Kingdom. We&apos;ll email shipping details to {order?.buyer_email || "you"} once your order ships.
            </p>
            {order && (
                <div className="card-flat p-6 mt-8 text-left max-w-lg mx-auto" data-testid="order-summary">
                    <div className="text-[10px] tracking-[0.3em] uppercase text-ink font-bold">Order</div>
                    <div className="font-mono text-sm text-gold mt-1">{order.id.slice(0, 8).toUpperCase()}</div>
                    <div className="mt-4 space-y-2">
                        {order.items.map((i, idx) => (
                            <div key={idx} className="text-sm flex justify-between">
                                <span>{i.product_name}{i.size ? ` · ${i.size}` : ""} × {i.quantity}</span>
                                <span className="font-bold">${(i.unit_price_cents * i.quantity / 100).toFixed(2)}</span>
                            </div>
                        ))}
                    </div>
                    <div className="border-t border-line mt-4 pt-3 flex justify-between font-bold">
                        <span>Total</span><span className="text-gold">${(order.total_cents / 100).toFixed(2)}</span>
                    </div>
                </div>
            )}
            <Link to="/store" className="inline-block btn-gold px-7 py-4 text-xs mt-8">Keep Shopping</Link>
        </div>
    );
}
